import { createPinia } from 'pinia'

// Single shared instance for the host app. Exported (rather than left local
// to app.js) so code that reads a store outside of Vue's injection context
// - e.g. share-module.js, which the module-share-uap bundles' own createVm()
// silently reassigns the global "active Pinia" against (see its
// `t.createPinia()` + `app.use(...)` call) - can pass it explicitly to
// useStore() and stay correct regardless of that pollution.
export const pinia = createPinia()
